import * as z from 'zod';
import { EntityId, Quantity, Tag } from '../base-schemas';
import { isoDateTimeToAppTime } from '../base-codecs';
import { LockData } from './Lock';
import { ReservableStatus } from './ReservableStatus';
export const ReservableResource = z.object({
    _tag: Tag('ReservableResource'),
    id: EntityId,
    reservable_product_id: EntityId,
    identifier: z.string(),
    is_available: z.boolean(),
    is_in_use: z.boolean(),
    notes: z.string().nullable(),
    created_at: isoDateTimeToAppTime.nullable(),
    updated_at: isoDateTimeToAppTime.nullable(),
    deleted_at: isoDateTimeToAppTime.nullable(),
    status: ReservableStatus,
    current_booking: z.object({
        item_id: EntityId,
        delivery_date_time: isoDateTimeToAppTime.nullable(),
        return_date_time: isoDateTimeToAppTime.nullable(),
        delivered_at: isoDateTimeToAppTime.nullable(),
        quantity: Quantity,
        customer: z.object({
            id: EntityId,
            name: z.string(),
            email: z.email().nullish()
        }).nullable(),
        booking_number: z.string().nullable()
    }).nullable(),
    upcoming_bookings_count: z.int().nonnegative().nullable(),
    lock: LockData.nullable().default(null)
});
